module.exports = __webpack_public_path__ + "../resources/img/ic_re_tv_p2.294a71a9.svg";